export const collections = [
  {
    id: 1,
    name: 'Space Savers',
    subtitle: 'Smart sofa beds built for compact living',
    pieces: 12,
    image: 'https://public.readdy.ai/ai/img_res/f27018fba3bd60f5514ee61419a1f95a.jpg',
  },
  {
    id: 2,
    name: 'Luxury Sleepers',
    subtitle: 'Premium comfort for guests and everyday use',
    pieces: 10,
    image: 'https://readdy.ai/api/search-image?query=elegant%20luxury%20living%20room%20with%20premium%20large%20sofa%20bed%20velvet%20upholstery%20warm%20ambient%20light%20gold%20accents%20sophisticated%20interior%20editorial%20photography%20high%20end%20design&width=800&height=600&seq=c2&orientation=landscape',
  },
  {
    id: 3,
    name: 'Studio Essentials',
    subtitle: 'Dual-purpose pieces for every studio',
    pieces: 8,
    image: 'https://readdy.ai/api/search-image?query=modern%20studio%20apartment%20interior%20minimalist%20sofa%20bed%20multipurpose%20furniture%20linen%20fabric%20warm%20neutral%20colors%20small%20space%20clever%20design%20editorial%20interior%20photography&width=800&height=600&seq=c3&orientation=landscape',
  },
  {
    id: 4,
    name: 'Family Sectionals',
    subtitle: 'Spacious sleepers for the whole family',
    pieces: 9,
    image: 'https://readdy.ai/api/search-image?query=large%20cozy%20family%20living%20room%20L-shape%20sectional%20sofa%20bed%20comfortable%20deep%20seats%20warm%20earth%20tones%20kids%20friendly%20interior%20editorial%20photography%20modern%20home%20design&width=800&height=600&seq=c4&orientation=landscape',
  },
  {
    id: 5,
    name: 'Modern Futons',
    subtitle: 'Clean lines, effortless conversion',
    pieces: 7,
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20bedroom%20with%20japanese%20futon%20sofa%20bed%20low%20profile%20wood%20frame%20natural%20cotton%20neutral%20tones%20zen%20interior%20editorial%20photography%20clean%20simple%20design&width=800&height=600&seq=c5&orientation=landscape',
  },
  {
    id: 6,
    name: 'Pull-Out Classics',
    subtitle: 'Time-tested comfort, built to last',
    pieces: 11,
    image: 'https://readdy.ai/api/search-image?query=classic%20comfortable%20pull%20out%20sofa%20bed%20traditional%20living%20room%20warm%20beige%20fabric%20hardwood%20frame%20cozy%20inviting%20guest%20room%20interior%20editorial%20photography%20warm%20lighting&width=800&height=600&seq=c6&orientation=landscape',
  },
];
